const customStyles = {
	control: (baseStyles, state) => ({
		...baseStyles,
		borderWidth: '1.5px',
		borderColor:
			state.isFocused || state.isSelected
				? 'var(--color-border-active)'
				: 'var(--color-border)',
		boxShadow: '',
		// Matches the focus ring in global-styles/buttons.scss.
		outline: state.isFocused ? '1.5px solid var(--color-link)' : 'none',
		outlineOffset: '2.5px',
		fontSize: 'var(--textsize-s)',
		':hover': {
			borderColor: 'var(--color-border-active)',
		},
	}),
	valueContainer: (baseStyles) => ({
		...baseStyles,
		paddingRight: '0',
	}),
	option: (baseStyles, state) => ({
		...baseStyles,
		backgroundColor: state.isFocused
			? 'var(--color-grey-050)'
			: 'var(--color-white)',
		color: 'var(--color-text)',
		padding: '0',
		marginTop: '1px',
	}),
	menu: (baseStyles) => ({
		...baseStyles,
		border: '0',
		borderRadius: '4px',
		boxShadow: '0 1px 6px 2px var(--color-active-shadow)',
		height: 'auto',
		margin: '4px 0 0',
		minWidth: 'min(300px, 90vw)',
		width: '100%',
		overflow: 'hidden',
		right: '0',
		zIndex: '1000', // otherwise the hit targets are often covered
	}),
};

export default customStyles;
